import type { FC } from 'react';
import styles from './PanelLeft.module.css';
import type { PanelLeftProps } from './PanelLeft.types';

export const PanelLeft: FC<PanelLeftProps> = ({ children }) => {
  return <aside className={styles.panelLeft}>{children}</aside>;
};
